import { h } from '@stencil/core';

const NavRight = () => {
  return (
    <svg width="25" height="32" viewBox="0 0 25 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_235_2844)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.41422 3.58582L6.58579 6.41424L13.1716 13L6.58579 19.5858L9.41422 22.4142L18.8284 13L9.41422 3.58582Z" fill="#fff" />
      </g>
      <defs>
        <filter id="filter0_d_235_2844" x="0.585785" y="0.585815" width="24.2426" height="30.8284" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_235_2844" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_235_2844" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default NavRight;
